import { z } from 'zod'

// ─────────────────────────────────────────────
// GET /{campaignSlug}/auth/check
// ─────────────────────────────────────────────

export const AuthCheckSuccessSchema = z.object({
  authenticated: z.literal(true),
  /** Cognito IdToken（JWT） */
  idToken: z.string(),
  /** IdToken の有効期限（Unix タイムスタンプ・秒） */
  expiresAt: z.number().int(),
})

export const AuthCheckErrorSchema = z.object({
  authenticated: z.literal(false),
  /**
   * no_session: Cookie なし
   * token_expired: IdToken 期限切れ
   */
  reason: z.enum(['no_session', 'token_expired']),
})

/** `authenticated` フィールドで判別する discriminated union */
export const AuthCheckResponseSchema = z.discriminatedUnion('authenticated', [
  AuthCheckSuccessSchema,
  AuthCheckErrorSchema,
])

export type AuthCheckSuccess = z.infer<typeof AuthCheckSuccessSchema>
export type AuthCheckError = z.infer<typeof AuthCheckErrorSchema>
export type AuthCheckResponse = z.infer<typeof AuthCheckResponseSchema>

// ─────────────────────────────────────────────
// POST /{campaignSlug}/token/refresh
// ─────────────────────────────────────────────

export const TokenRefreshSuccessSchema = z.object({
  /** 新しい Cognito IdToken（JWT） */
  idToken: z.string(),
  /** 新しい Cognito AccessToken（JWT） */
  accessToken: z.string(),
  /** IdToken の有効期限（Unix タイムスタンプ・秒） */
  expiresAt: z.number().int(),
})

export const TokenRefreshErrorSchema = z.object({
  error: z.enum(['unauthorized', 'invalid_grant']),
})

export type TokenRefreshSuccess = z.infer<typeof TokenRefreshSuccessSchema>
export type TokenRefreshError = z.infer<typeof TokenRefreshErrorSchema>
